import { useState } from "react"
import { useAuth } from "react-oidc-context"
import { AppShell } from "../components/AppShell"
import { useApi } from "../api/hooks"
import { useT } from "../lib/i18n"

export function SettingsPage() {
  const auth = useAuth()
  const api = useApi()
  const { t } = useT()
  const [busy, setBusy] = useState<"export" | "delete" | null>(null)
  const [msg, setMsg] = useState<string | null>(null)
  const [err, setErr] = useState<string | null>(null)

  async function onExport() {
    setBusy("export")
    setErr(null); setMsg(null)
    try {
      const r = await api.post<{ export_url: string; rows: number; receipts: number }>("/me/export", {})
      setMsg(t("settings_export_ok", { rows: r.rows, receipts: r.receipts }))
      window.open(r.export_url, "_blank", "noopener,noreferrer")
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : String(e))
    } finally {
      setBusy(null)
    }
  }

  async function onDelete() {
    if (!confirm(t("settings_confirm_delete"))) return
    setBusy("delete")
    setErr(null); setMsg(null)
    try {
      await api.delete<{ deleted: boolean }>("/me")
      setMsg(t("settings_deleted_ok"))
      setTimeout(() => { void auth.signoutRedirect() }, 1500)
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : String(e))
    } finally {
      setBusy(null)
    }
  }

  return (
    <AppShell>
      <h1 style={{ margin: 0, fontSize: 28 }}>{t("settings_title")}</h1>
      <p style={{ color: "var(--muted)" }}>
        {t("settings_account")}: <code>{auth.user?.profile?.email}</code>
      </p>

      <section style={section}>
        <h2 style={h2}>{t("settings_data_section")}</h2>
        <p style={p}>
          {t("settings_export_desc")}
        </p>
        <button onClick={onExport} disabled={busy !== null} style={primaryBtn}>
          {busy === "export" ? t("settings_generating") : t("settings_export_btn")}
        </button>
      </section>

      <section style={{ ...section, borderColor: "#ff7a85" }}>
        <h2 style={{ ...h2, color: "#ff7a85" }}>{t("settings_danger")}</h2>
        <p style={p}>
          {t("settings_delete_desc")}
        </p>
        <button onClick={onDelete} disabled={busy !== null} style={dangerBtn}>
          {busy === "delete" ? t("settings_deleting") : t("settings_delete_btn")}
        </button>
      </section>

      {msg && <p style={{ color: "var(--accent)", marginTop: 24 }}>{msg}</p>}
      {err && <p style={{ color: "#ff7a85", marginTop: 24 }}>{err}</p>}
    </AppShell>
  )
}

const section: React.CSSProperties = {
  marginTop: 32, padding: 20, border: "1px solid var(--border)",
  borderRadius: "var(--radius)", background: "var(--surface)",
}
const h2: React.CSSProperties = { margin: 0, fontSize: 16, color: "var(--text)" }
const p: React.CSSProperties = { color: "var(--muted)", marginBottom: 16 }
const primaryBtn: React.CSSProperties = {
  background: "var(--accent)", color: "var(--accent-fg)",
  border: "none", borderRadius: 8, padding: "8px 14px",
  cursor: "pointer", fontWeight: 600,
}
const dangerBtn: React.CSSProperties = {
  background: "#ff7a85", color: "#1a0000",
  border: "none", borderRadius: 8, padding: "8px 14px",
  cursor: "pointer", fontWeight: 600,
}
